export default __webpack_public_path__ + "static/media/mail.50ad32d9.svg";